import Api from "./Api";

export default {
  getRootCategories: async () => await Api().get('category/get-root-categories'),
  getCategories: async ({rootCategory}) => await Api().get('category/get-categories', {params: {rootCategory}}),
  getPartsTags: async ({rootCategory, category}) => await Api().get('category/get-parts-tags', {params: {rootCategory, category}})
};
